import { useMutation, useQueryClient } from '@tanstack/react-query';
import fetchSRS from '../../../utils/fetchSRS';
import sportsApi from '../../../utils/sportsApi';

const useArchiveReport = ({
    pptReporting,
    clientId,
}: {
    pptReporting: boolean;
    clientId: number;
}) => {
    const queryClient = useQueryClient();

    const archiveReport = async (reportId: string) => {
        if (!pptReporting) {
            await sportsApi
                .url(`/clients/${clientId}/mvc-reports/${reportId}`)
                .delete();
        } else {
            await fetchSRS
                .url(`/reports/${reportId}`)
                .json({ action: 'archive' })
                .post()
                .json();
        }
    };

    const mutation = useMutation({
        mutationFn: archiveReport,
        onSuccess: (_, reportId) => {
            queryClient.setQueryData(
                ['historyData', clientId, pptReporting],
                (oldData: any) => {
                    // Ensure oldData is an array, default to empty array if not
                    const existingData = Array.isArray(oldData) ? oldData : [];
                    return existingData.filter(
                        (d: any) => d.reportId !== reportId,
                    );
                },
            );
        },
    });

    return mutation;
};

export default useArchiveReport;
